<template>
  <div class="nav-menu">
    <!-- 导航图标按钮 -->
    <div class="nav-right">
      <slot name="right"></slot>
      <van-icon
        name="apps-o"
        size="20"
        @click="toggleNav"
        class="nav-icon"
      />
    </div>
    
    <!-- 导航菜单弹窗，使用Teleport渲染到body -->
    <Teleport to="body">
      <van-popup v-model:show="showNav" position="right" :style="{ width: '60%', height: '100%' }" :z-index="9999">
        <div class="nav-popup">
          <div class="nav-header">
            <h3 class="nav-title">导航菜单</h3>
            <van-icon name="cross" size="20" @click="showNav = false" class="nav-close" />
          </div>
          <div class="nav-list">
            <div
              v-for="item in tabbarItems"
              :key="item.path"
              class="nav-item"
              @click="navigateTo(item.path)"
            >
              <van-icon :name="item.icon || item.meta.icon" size="18" class="nav-item-icon" />
              <span class="nav-item-text">{{ item.title || item.meta.title }}</span>
            </div>
          </div>
        </div>
      </van-popup>
    </Teleport>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { tabbarItems } from '../../config/tabbar'

const router = useRouter()

// 导航菜单显示状态
const showNav = ref(false)

// 切换导航菜单显示/隐藏
const toggleNav = () => {
  showNav.value = !showNav.value
}

// 导航到指定页面
const navigateTo = (path) => {
  showNav.value = false
  router.push(path)
}
</script>

<style scoped>
.van-popup{border-radius: 0;}
.nav-menu {
  position: relative;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-icon {
  cursor: pointer;
}

.nav-popup {
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.nav-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #eee;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.nav-close {
  cursor: pointer;
}

.nav-list {
  flex: 1;
  padding: 16px 0;
  overflow-y: auto;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.nav-item:hover {
  background-color: #f5f5f5;
}

.nav-item-icon {
  margin-right: 12px;
  color: #666;
}

.nav-item-text {
  font-size: 16px;
  color: #333;
}
</style>